import script from "./ImpressumPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImpressumPage.vue?vue&type=script&setup=true&lang=ts"

import "./ImpressumPage.vue?vue&type=style&index=0&id=37f481c2&scoped=true&lang=css"

import exportComponent from "../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37f481c2"]])

export default __exports__